export interface InformationProps {
  passwordFieldIsOpen: boolean;
}

export const WARNING_HREF =
  "http://www.akbank.com/tr-tr/genel/Sayfalar/Guvenlik-Duyurulari.aspx";
